import { Badge } from '@/platform/ui';
import {
    CheckCircleIcon,
    MinusCircleIcon,
    XCircleIcon,
} from '@heroicons/react/20/solid';
import { usePage } from '@inertiajs/react';
import { groupByQuestion, questionnaireSubtitle } from './questionnaire';
import SidePanel, { closePanel } from './SidePanel';

const ANSWERS = {
    true: { Icon: CheckCircleIcon, className: 'text-green-600', label: 'Ja' },
    false: { Icon: XCircleIcon, className: 'text-red-600', label: 'Nee' },
    null: {
        Icon: MinusCircleIcon,
        className: 'text-gray-400',
        label: 'Niet beantwoord',
    },
};

const QuestionnairePanel = () => {
    const { employee, questionnaire } = usePage().props;

    const questions = groupByQuestion(questionnaire.questions ?? []);

    return (
        <SidePanel
            title={
                <>
                    Vragenlijst
                    <Badge color={questionnaire.state_color}>
                        {questionnaire.state_label}
                    </Badge>
                </>
            }
            subtitle={questionnaireSubtitle(employee, questionnaire)}
            onClose={() =>
                closePanel(
                    `/customers/${employee.customer_id}/employees/${employee.id}/questionnaires`
                )
            }
        >
            {questions.length === 0 ? (
                <p className='text-sm text-gray-500'>
                    Deze vragenlijst heeft geen vragen.
                </p>
            ) : (
                <ol className='flex flex-col gap-6'>
                    {questions.map((question, index) => (
                        <li key={question.id}>
                            <p className='mb-2 text-sm font-semibold text-gray-900'>
                                {index + 1}. {question.question}
                            </p>
                            <ul className='flex flex-col gap-1.5'>
                                {question.options.map(option => {
                                    const answer =
                                        ANSWERS[option.answer] ?? ANSWERS.null;

                                    return (
                                        <li
                                            key={option.id}
                                            className='flex items-start gap-2 text-sm text-gray-700'
                                        >
                                            <answer.Icon
                                                aria-hidden='true'
                                                className={`mt-0.5 size-4 shrink-0 ${answer.className}`}
                                            />
                                            <span>
                                                {option.option}
                                                <span className='sr-only'>
                                                    {' '}
                                                    ({answer.label})
                                                </span>
                                            </span>
                                        </li>
                                    );
                                })}
                            </ul>
                        </li>
                    ))}
                </ol>
            )}
        </SidePanel>
    );
};

export default QuestionnairePanel;
